import React from 'react'
import { Field, useForm } from 'react-final-form'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

import FormError from './FormError'

type FormFieldProps = {
  id: string
  name: string
  type: string
  helperText?: string
  placeholder?: string
  inputProps?: any
  InputProps?: any
  style?: any
  onInputChange?: (e: any) => void
  inputValue?: any
  isAutoComplete?: boolean
  autocompleteData?: any[]
}

const FormField = ({
  id,
  name,
  type,
  helperText,
  placeholder,
  style,
  inputProps = {},
  InputProps,
  inputValue,
  onInputChange,
  isAutoComplete = false,
  autocompleteData = [],
}: FormFieldProps) => {
  const form = useForm()

  return (
    <React.Fragment>
      <Field id={id} name={name} type={type} component="input">
        {({ input: { value, onChange, name } }) =>
          isAutoComplete ? (
            <Autocomplete
              options={autocompleteData}
              id={id}
              sx={{
                '& .MuiOutlinedInput-root': {
                  padding: '9px 14px !important',
                },
              }}
              value={value ? value : { code: '', description: '' }}
              onChange={(
                e: any,
                value: { code: string; description: string }
              ) => {
                form.change(name, value)
              }}
              getOptionLabel={(option: any) => option.description}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  name={name}
                  // value={inputValue ? inputValue : value}
                  // type={type}
                  onChange={(e) => {
                    if (onInputChange) {
                      onInputChange(e)
                    }
                  }}
                  helperText={helperText}
                  placeholder={placeholder}
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: `primary.main`,
                      },
                      '&:hover fieldset': {
                        borderColor: `primary.main`,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: `primary.main`,
                        borderWidth: `1px !important`,
                      },
                    },
                    ...style,
                  }}
                  InputProps={{
                    ...params?.InputProps,
                    ...InputProps,
                  }}
                />
              )}
            />
          ) : (
            <TextField
              variant="outlined"
              name={name}
              value={inputValue ? inputValue : value}
              type={type}
              onChange={(e) => {
                onChange(e)

                if (onInputChange) {
                  onInputChange(e)
                }
              }}
              helperText={helperText}
              placeholder={placeholder}
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: `primary.main`,
                  },
                  '&:hover fieldset': {
                    borderColor: `primary.main`,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: `primary.main`,
                    borderWidth: `1px !important`,
                  },
                },
                ...style,
              }}
              InputProps={InputProps}
              inputProps={inputProps}
            />
          )
        }
      </Field>
      <FormError name={name} />
    </React.Fragment>
  )
}

export default FormField
